import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import ScheduleIcon from '@mui/icons-material/ScheduleOutlined';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHighOutlined';
import VerifiedIcon from '@mui/icons-material/VerifiedOutlined';

const Container = styled(Box)({
  marginTop: 28,
  padding: '20px 24px',
  borderRadius: 12,
  background: 'rgba(46,196,182,0.05)',
  border: '1px dashed rgba(46,196,182,0.3)',
});

const SectionLabel = styled(Typography)({
  fontFamily: 'Helvetica Inserat, Impact, sans-serif',
  fontSize: '0.7rem',
  letterSpacing: '0.32em',
  color: '#1a7a72',
  textTransform: 'uppercase',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: 14,
});

const Row = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 12,
  padding: '8px 0',
  '& + &': { borderTop: '1px dashed rgba(46,196,182,0.18)' },
});

const IconWrap = styled(Box)({
  flexShrink: 0,
  color: '#2ec4b6',
  marginTop: 2,
});

const Text = styled(Typography)({
  fontSize: '0.9rem',
  color: '#444',
  lineHeight: 1.4,
  '& b': {
    color: '#1a7a72',
    fontFamily: 'Helvetica Inserat, Impact, sans-serif',
    fontWeight: 800,
    letterSpacing: '0.04em',
  },
});

const BENEFITS = [
  { Icon: ScheduleIcon, lead: 'Custom for you.', body: ' Every question is written from scratch for your theme and group — no canned trivia pulled from a database.' },
  { Icon: AutoFixHighIcon, lead: 'Hand-built for the room.', body: ' Categories and difficulty are tuned to the tone and audience you picked.' },
  { Icon: VerifiedIcon, lead: 'Quality-checked.', body: ' Every question gets vetted for accuracy and clarity before it makes the board.' },
];

const BenefitsPanel = () => (
  <Container>
    <SectionLabel>Why This Takes a Minute</SectionLabel>
    {BENEFITS.map(({ Icon: BIcon, lead, body }, i) => (
      <Row key={i}>
        <IconWrap><BIcon sx={{ fontSize: 22 }} /></IconWrap>
        <Text><b>{lead}</b>{body}</Text>
      </Row>
    ))}
  </Container>
);

export default BenefitsPanel;
